<template>
  <div class="products-page">
    <section class="products-hero">
      <h1>{{ $t('products.title') }}</h1>
      <p>{{ $t('products.subtitle') }}</p>
    </section>

    <section class="product-list">
      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/cdn.svg" alt="CDN" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.cdn.title') }}</h3>
          <p>{{ $t('products.items.cdn.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.cdn.features[0]') }}</li>
            <li>{{ $t('products.items.cdn.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>


      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/waf.svg" alt="WAF" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.waf.title') }}</h3>
          <p>{{ $t('products.items.waf.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.waf.features[0]') }}</li>
            <li>{{ $t('products.items.waf.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>


      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/edge-computing.svg" alt="Edge Computing" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.edgeComputing.title') }}</h3>
          <p>{{ $t('products.items.edgeComputing.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.edgeComputing.features[0]') }}</li>
            <li>{{ $t('products.items.edgeComputing.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>


      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/image-optimization.svg" alt="Image Optimization" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.imageOptimization.title') }}</h3>
          <p>{{ $t('products.items.imageOptimization.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.imageOptimization.features[0]') }}</li>
            <li>{{ $t('products.items.imageOptimization.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>


      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/ddos.svg" alt="DDoS Protection" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.ddosProtection.title') }}</h3>
          <p>{{ $t('products.items.ddosProtection.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.ddosProtection.features[0]') }}</li>
            <li>{{ $t('products.items.ddosProtection.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>

      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/analytics.svg" alt="Real-time Analytics" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.realTimeAnalytics.title') }}</h3>
          <p>{{ $t('products.items.realTimeAnalytics.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.realTimeAnalytics.features[0]') }}</li>
            <li>{{ $t('products.items.realTimeAnalytics.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>


      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/api-acceleration.svg" alt="API Acceleration" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.apiAcceleration.title') }}</h3>
          <p>{{ $t('products.items.apiAcceleration.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.apiAcceleration.features[0]') }}</li>
            <li>{{ $t('products.items.apiAcceleration.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>

      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/video-streaming.svg" alt="Video Streaming" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.videoStreaming.title') }}</h3>
          <p>{{ $t('products.items.videoStreaming.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.videoStreaming.features[0]') }}</li>
            <li>{{ $t('products.items.videoStreaming.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>

      <div class="product-item">
        <div class="product-icon">
          <img src="@/assets/images/load-balancing.svg" alt="Global Load Balancing" />
        </div>
        <div class="product-content">
          <h3>{{ $t('products.items.globalLoadBalancing.title') }}</h3>
          <p>{{ $t('products.items.globalLoadBalancing.desc') }}</p>
          <ul>
            <li>{{ $t('products.items.globalLoadBalancing.features[0]') }}</li>
            <li>{{ $t('products.items.globalLoadBalancing.features[1]') }}</li>
          </ul>
          <router-link to="/about#contact-us" class="learn-more">{{ $t('products.learnMore') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProductsPage'
}
</script>

<style scoped>
.products-page {
  background-color: var(--background-light);
  min-height: 100vh;
}

.products-hero {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  margin-bottom: 3rem;
}

.products-hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.products-hero p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.product-list {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem 4rem;
}

.product-item {
  display: flex;
  align-items: center;
  gap: 3rem;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
  margin-bottom: 2rem;
  transition: all 0.3s ease;
}

.product-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.product-icon {
  flex-shrink: 0;
}

.product-icon img {
  width: 80px;
  height: 80px;
}

.product-content {
  flex: 1;
}

.product-content h3 {
  color: var(--text-primary);
  font-size: 1.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.product-content p {
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.product-content ul {
  list-style: none;
  padding: 0;
  margin-bottom: 1.5rem;
}

.product-content ul li {
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
  padding-left: 1.5rem;
  position: relative;
}

.product-content ul li::before {
  content: "•";
  color: var(--primary-color);
  position: absolute;
  left: 0;
  font-weight: bold;
}

.learn-more {
  padding: 0.6rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.learn-more:hover {
  background-color: var(--primary-light);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .product-item {
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
  }

  .product-icon img {
    width: 80px;
    height: 80px;
  }

  .products-hero h1 {
    font-size: 2rem;
  }
}
</style> 